import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import { GridColumn } from '@atlaskit/page';

// @source
import { Fragment, CoverageSpinner } from '../../../../components';
import * as Styled from '../../styled';
import AddButton from './AddButton';
import RemoveButton from './RemoveButton';
import TableGroup from './TableGroup';
import TableHead from './TableHead';
import TableRow from './TableRow';

class DynamicSelection extends Component {
  getUnSelectedItems() {
    const group = this.props.items.find(item => item.title === this.props.table);
    if (group) {
      return group.children.filter(child => !child.isSelected && child.type === 'numeric');
    }

    return [];
  }

  getSelectedItems() {
    const items = this.props.items.reduce((list, item) => {
      const children = item.children.filter(child => child.isSelected && child.type === 'numeric');
      if (children.length) {
        list.push({ ...item, children });
      }
      return list;
    }, []);

    return items;
  }

  render() {
    const gridSize = window.outerWidth < 768 ? 12 : 6;
    const unselected = this.getUnSelectedItems();
    const selected = this.getSelectedItems();

    return (
      <Fragment>
        <GridColumn medium={gridSize}>
          <Styled.TableScope>
            <Styled.Table>
              <TableHead
                title={this.props.table}
                action={(
                  <AddButton
                    content="Add all columns"
                    onClick={() => this.props.onToggleGroup(this.props.table, true)}
                    isDisabled={!unselected.length}
                  />
                )}
              />
              {unselected.map(item => (
                <TableRow
                  key={item.name}
                  text={item.name}
                  action={(
                    <AddButton
                      content="Add column"
                      onClick={() => this.props.onToggleColumn(this.props.table, item.name)}
                    />
                  )}
                />
              ))}
              <Fragment render={!unselected.length && !this.props.isLoading}>
                <p>You have selected all the columns.</p>
              </Fragment>
              <Fragment render={this.props.isLoading}>
                <CoverageSpinner />
              </Fragment>
            </Styled.Table>
          </Styled.TableScope>
        </GridColumn>
        <GridColumn medium={gridSize}>
          <Styled.TableScope>
            <Styled.Table>
              <TableHead title="Groups" />
              {selected.map(item => (
                <TableGroup
                  {...item}
                  key={item.title}
                  onClick={() => this.props.onToggleGroup(item.title, false)}
                  onClickVisible={this.props.onToggleGroupVisible}
                >
                  <Fragment render={item.isOpen}>
                    {item.children.map(child => (
                      <TableRow
                        key={child.name}
                        text={child.name}
                        action={(
                          <RemoveButton
                            content="Remove column"
                            onClick={() => this.props.onToggleColumn(item.title, child.name)}
                          />
                        )}
                      />
                    ))}
                  </Fragment>
                </TableGroup>
              ))}
              <Fragment render={!selected.length}>
                <p>You don&#39;t have any selection.</p>
              </Fragment>
            </Styled.Table>
          </Styled.TableScope>
        </GridColumn>
      </Fragment>
    );
  }
}

DynamicSelection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  onToggleColumn: PropTypes.func.isRequired,
  onToggleGroup: PropTypes.func.isRequired,
  onToggleGroupVisible: PropTypes.func.isRequired,
  table: PropTypes.string.isRequired,
};

export default DynamicSelection;
